export const SleepingCustomerRoute = "/fehlendedaten/:category/sc/:tariffId";
